import type { BrandDefinition } from '../types';
import {
  disabledAdminModules,
  disabledStorefrontPaths,
} from './routes';
import { tenantDefaults } from './tenantDefaults';
import { tenantModuleGroups } from './nav';

/**
 * Alive Album — photographer galleries for clients (no commerce).
 * Tenants are created from platform admin; this pack does not seed one.
 */
const brand: BrandDefinition = {
  id: 'alivealbum',
  displayName: 'Alive Album',
  domains: {
    apex: 'alivealbum.online',
    tenantSuffix: 'alivealbum.online',
  },
  capabilities: {
    commerce: false,
    biography: false,
    platformDirectory: true,
    lightroom: false,
    telegram: true,
    editorialCollection: true,
    manualProductSku: false,
  },
  tenantDefaults: {
    listOnPlatform: tenantDefaults.listOnPlatform,
    allowGuestCart: tenantDefaults.allowGuestCart,
    allowGuestOrders: tenantDefaults.allowGuestOrders,
  },
  tenantModuleGroups,
  disabledStorefrontPaths,
  disabledAdminModules,
  components: {
    PlatformLanding: null,
  },
};

export default brand;
